import { Injectable } from '@angular/core';
import { Product, ProductIngredient } from './cart.model';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  cart: Product[] = [];
  private totalElements = new Subject<number>();
  totalElements$ = this.totalElements.asObservable();
  private subtotal = new Subject<number>();
  subtotal$ = this.subtotal.asObservable();

  productList = [
    {
      productId: 1,
      productType: 1,
      name: 'SEGURO PARA CENTROS DE BUCEO',
      price: 850,
      extraPrice: 0,
      description: `<p>Ofrecemos a los centros y escuelas de buceo el seguro más completo del mercado que incluye todas las exigencias legales para la operación de un centro de buceo.</p>
<p>Nuestro seguro incluye:</p>
<ul>
    <li>Límite asegurado de 4.000.000 Euros.</li>
    <li>La responsabilidad civil ante los empleados. </li>
    <li>La responsabilidad civil de todas las embarcaciones del centro o escuela hasta 8 mts. de eslora</li>
    <li>La responsabilidad civil de los accidentes ocurridos a bordo de la embarcación.</li>
    <li>La responsabilidad civil de los compresores del centro. </li>
    <li>La responsabilidad civil de todos los instructores y Dive Masters del centro o escuela.</li>
    <li>Cubre el buceo técnico con Nitrox y Trimix.</li>
    <li>Incluye una tarifa plana para los accidentes de sus alumnos de cursos de iniciación sin necesidad de registrarlos</li>
</ul>`,
      ingredients: [],
      finalIngredients: [],
      finalIngredientsName: [],
      image_url: 'assets/img/temp/Imagen6.jpg',
      quantity: 1,
      inventoryStatus: 'INSTOCK',
    },
    // {
    //   productId: 2,
    //   productType: 1,
    //   name: 'Producto estándar',
    //   price: 55,
    //   extraPrice: 0,
    //   description: 'Producto individual vista a la montaña',
    //   ingredients: [],
    //   finalIngredients: [],
    //   finalIngredientsName: [],
    //   image_url: 'assets/img/product/habitacion-simple.jpg',
    //   quantity: 1,
    //   inventoryStatus: 'INSTOCK',
    // },
    {
      productId: 3,
      productType: 2,
      name: 'SEGURO PARA CENTROS DE BUCEO plus',
      price: 950,
      extraPrice: 0,
      description: `<p>Ofrecemos a los centros y escuelas de buceo el seguro más completo del mercado que incluye todas las exigencias legales para la operación de un centro de buceo.</p>
<p>Nuestro seguro incluye:</p>
<ul>
    <li>Límite asegurado de 4.000.000 Euros.</li>
    <li>La responsabilidad civil ante los empleados. </li>
    <li>La responsabilidad civil de todas las embarcaciones del centro o escuela hasta 15 mts. de eslora</li>
    <li>La responsabilidad civil de los accidentes ocurridos a bordo de la embarcación.</li>
    <li>La responsabilidad civil de los compresores del centro. </li>
    <li>La responsabilidad civil de todos los instructores y Dive Masters del centro o escuela.</li>
    <li>Cubre el buceo técnico con Nitrox y Trimix.</li>
    <li>Incluye una tarifa plana para los accidentes de sus alumnos de cursos de iniciación sin necesidad de registrarlos</li>
</ul>`,
      ingredients: [1, 2, 3],
      finalIngredients: [1, 2, 3],
      finalIngredientsName: [],
      image_url: 'assets/img/temp/Imagen3.jpg',
      quantity: 1,
      inventoryStatus: 'INSTOCK',
    },
    // {
    //   productId: 4,
    //   productType: 2,
    //   name: 'Producto doble matrimonio montaña',
    //   price: 99,
    //   extraPrice: 0,
    //   description:
    //     'Producto doble en nuestro encantador hotel. Esta Producto está equipada con una cómoda camas de matrimonio, perfectas para tu comodidad y descanso.',
    //   ingredients: [1, 2, 3],
    //   finalIngredients: [1, 2, 3],
    //   finalIngredientsName: [],
    //   image_url: 'assets/img/product/habitacion-simple.jpg',
    //   quantity: 1,
    //   inventoryStatus: 'INSTOCK',
    // },
    // {
    //   productId: 5,
    //   productType: 2,
    //   name: 'Producto doble matrimonio',
    //   price: 99,
    //   extraPrice: 0,
    //   description:
    //     'Producto doble en nuestro encantador hotel. Esta Producto está equipada con una cómoda camas de matrimonio, perfectas para tu comodidad y descanso.',
    //   ingredients: [1, 2, 3],
    //   finalIngredients: [1, 2, 3],
    //   finalIngredientsName: [],
    //   image_url: 'assets/img/product/habitacion-simple.jpg',
    //   quantity: 1,
    //   inventoryStatus: 'INSTOCK',
    // },
    // {
    //   productId: 6,
    //   productType: 3,
    //   name: 'Producto triple',
    //   price: 125,
    //   extraPrice: 0,
    //   description:
    //     'Producto doble en nuestro encantador hotel. Esta Producto está equipada con dos cómodas camas individuales, perfectas para tu comodidad y descanso. Si su preferencia es cama matrimonial, comuniquelo al reservar y haremos todo lo posible por satisfacer sus preferencias, según disponibilidad.',
    //   ingredients: [1, 2, 3],
    //   finalIngredients: [1, 2, 3],
    //   finalIngredientsName: [],
    //   image_url: 'assets/img/product/habitacion-simple.jpg',
    //   quantity: 1,
    //   inventoryStatus: 'INSTOCK',
    // },
    // {
    //   productId: 7,
    //   productType: 4,
    //   name: 'Producto 4pax',
    //   price: 149,
    //   extraPrice: 0,
    //   description:
    //     'Producto doble en nuestro encantador hotel. Esta Producto está equipada con tres cómodas camas individuales junto a un sofa cama, perfectas para tu comodidad y descanso. Si su preferencia es cama matrimonial, comuniquelo al reservar y haremos todo lo posible por satisfacer sus preferencias, según disponibilidad.',
    //   ingredients: [1, 2, 3],
    //   finalIngredients: [1, 2, 3],
    //   finalIngredientsName: [],
    //   image_url: 'assets/img/product/habitacion-simple.jpg',
    //   quantity: 1,
    //   inventoryStatus: 'INSTOCK',
    // },
    // {
    //   productId: 8,
    //   productType: 4,
    //   name: 'Producto 4pax',
    //   price: 149,
    //   extraPrice: 0,
    //   description:
    //     'Producto para 4 personas en nuestro encantador hotel. Esta Producto está equipada con tres cómodas camas individuales junto a un sofa cama, perfectas para tu comodidad y descanso. Si su preferencia es cama matrimonial, comuniquelo al reservar y haremos todo lo posible por satisfacer sus preferencias, según disponibilidad.',
    //   ingredients: [1, 2, 3],
    //   finalIngredients: [1, 2, 3],
    //   finalIngredientsName: [],
    //   image_url: 'assets/img/product/habitacion-simple.jpg',
    //   quantity: 1,
    //   inventoryStatus: 'INSTOCK',
    // },
  ];

  comboList = [
    {
      comboId: 1,
      products: [1, 3, 14, 14],
      name: 'Pizza Party',
      price: 20,
      extraPrice: 0,
      description: '1 Pizza Hawai + 1 Pizza Salami + 2 Pepsi Max',
      ingredients: [1, 2, 3],
      finalIngredients: [1, 2, 3],
      image_url: 'assets/img/combos/combo1.webp',
      quantity: 1,
    },
  ];

  ingredientsList: ProductIngredient[] = [
    {
      productIngredientId: 1,
      name: 'Ducha',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/peperoni.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 2,
      name: 'Secador',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/jamon.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 3,
      name: 'Balcón',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/champinon.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 4,
      name: 'Piña',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/pina.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 5,
      name: 'Atún',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/atun.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 6,
      name: 'Alcachofas',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/alcachofa.webp',
      initialQuantity: 0,
    },
    {
      productIngredientId: 7,
      name: 'Pimiento pìcante',
      price: 1.0,
      totalPrice: 0,
      image_url: 'assets/img/ingredients/pimiento.webp',
      initialQuantity: 0,
    },
  ];

  constructor() {
    const storage: string | null = localStorage.getItem('cart');
    if (storage) {
      this.cart = JSON.parse(storage);
      this.setTotalElements();
      this.calculateSubtotalAmount();
    }
  }

  addProduct(product: Product, quantity: number) {
    const newProduct: Product = product;
    console.log('addProduct', quantity, newProduct);
    this.cart.push(newProduct);
    this.updateStorage();
  }

  removeProduct(index: number) {
    this.cart = this.cart.filter((product, cartIndex) => cartIndex != index);
    this.updateStorage();
  }

  changeProductQuantity(index: number, value: number) {
    this.cart = this.cart.map((product, cartIndex) => {
      const currentProduct: Product = { ...product };
      if (cartIndex === index) {
        currentProduct.quantity = value;
      }
      return currentProduct;
    });

    this.updateStorage();
  }

  updateStorage() {
    console.log('CURRENT CART', this.cart);

    localStorage.setItem('cart', JSON.stringify(this.cart));
    this.setTotalElements();
    this.calculateSubtotalAmount();
  }

  emptyCart() {
    this.cart = [];
    this.updateStorage();
  }

  setTotalElements() {
    let totalElements = 0;
    this.cart.forEach(element => {
      totalElements += element.quantity;
    });
    this.totalElements.next(totalElements);
    return totalElements;
  }

  calculateSubtotalAmount() {
    let subtotal = 0;
    this.cart.forEach(element => {
      subtotal += Number(element.quantity) * Number(element.price || 0);
    });

    this.subtotal.next(subtotal);
    return subtotal;
  }
}
